import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_FormModalShell = _resolveComponent("FormModalShell")!
  const _directive_dialog_auto_focus = _resolveDirective("dialog-auto-focus")!

  return (_openBlock(), _createBlock(_component_FormModalShell, {
    "is-display": _ctx.isOpen,
    title: _ctx.titleDisplay,
    size: "xl",
    onClose: _ctx.onClose
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_ButtonCustom, {
        "button-type": _ctx.ButtonsType.SAVE,
        "color-type": _ctx.ButtonTypeColors.SUCCESS,
        onClick: _ctx.submit
      }, {
        "button-label": _withCtx(() => [
          _createTextVNode("Lưu")
        ]),
        _: 1
      }, 8, ["button-type", "color-type", "onClick"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.searchTerm,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
          class: "mb-3",
          style: {"width":"20rem"},
          placeholder: "Tìm toa xe",
          onInput: _ctx.search
        }, null, 8, ["modelValue", "onInput"]),
        _createVNode(_component_el_table, {
          style: {"width":"100%"},
          "max-height": "500",
          "empty-text": "Không có dữ liệu",
          "row-class-name": "table-row",
          size: "medium",
          border: true,
          data: _ctx.toaXeItems
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { width: "55" }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.selectedToaXeIdArr[scope.$index],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.selectedToaXeIdArr[scope.$index]) = $event),
                  onChange: 
                (value) =>
                  _ctx.changeToaXeCheckboxHandler({
                    row: scope.row,
                    value,
                  })
              
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "STT",
              width: "60"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.indexCal(scope.$index, _ctx.currentPage, _ctx.perPage)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "ID",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.id), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Tên" }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.ten_toa_xe), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Mã Toa xe" }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.ma_toa_xe), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Chủng loại" }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.chung_loai_toa_xe?.ky_hieu
                ? scope.row.chung_loai_toa_xe?.ky_hieu
                : '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Ghi chú" }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.ghi_chu ? scope.row.ghi_chu : '-'), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        (_ctx.toaXeItems.length > 0)
          ? (_openBlock(), _createBlock(_component_Pagination, {
              key: 0,
              page: _ctx.currentPage,
              "page-size": _ctx.perPage,
              "show-per-page": false,
              total: _ctx.totalItems,
              onChangePage: _cache[1] || (_cache[1] = (value) => (_ctx.currentPage = value))
            }, null, 8, ["page", "page-size", "total"]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_dialog_auto_focus, _ctx.isOpen]
      ])
    ]),
    _: 1
  }, 8, ["is-display", "title", "onClose"]))
}